// components/layout/DashboardLayout.jsx
import React from 'react';
import { Layout, Breadcrumb, Space } from 'antd';
import Sidebar from '../common/Sidebar';

const { Content } = Layout;

const DashboardLayout = ({ 
  title, 
  subtitle, 
  headerActions = [], 
  breadcrumbs = [], 
  children,
  className = ""
}) => {
  const safeHeaderActions = Array.isArray(headerActions) ? headerActions : [];
  const safeBreadcrumbs = Array.isArray(breadcrumbs) ? breadcrumbs : [];
  
  // Convert breadcrumbs to new format
  const breadcrumbItems = safeBreadcrumbs.map((breadcrumb, index) => ({
    title: (
      <span 
        className={`text-xs sm:text-sm ${breadcrumb.onClick ? 'cursor-pointer hover:text-blue-600' : ''}`}
        onClick={breadcrumb.onClick}
      >
        {breadcrumb.title}
      </span>
    )
  }));
  
  return (
    <Layout className="min-h-screen bg-gray-50 flex flex-row">
      {/* Sidebar */}
      <Sidebar />
      <Content className="flex flex-col flex-1 overflow-hidden">
        {/* Fixed Header */}
        <div className="flex-shrink-0 bg-white border-b border-gray-200 shadow-sm">
          <div className="px-4 sm:px-6 py-4">
            {/* Breadcrumbs - Using new items prop */}
            {breadcrumbItems.length > 0 && (
              <Breadcrumb 
                className="mb-2"
                items={breadcrumbItems}
              />
            )}
            
            {/* Header Content */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 truncate">
                  {title}
                </h1>
                {subtitle && (
                  <p className="text-xs sm:text-sm text-gray-600 mt-1 truncate">
                    {subtitle}
                  </p>
                )}
              </div>
              
              {/* Header Actions */}
              {safeHeaderActions.length > 0 && (
                <div className="flex-shrink-0">
                  <Space 
                    size="small" 
                    wrap
                    className="flex justify-end sm:justify-start"
                  >
                    {safeHeaderActions}
                  </Space>
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* Main Content */}
        <div className={`flex-1 overflow-auto ${className}`}>
          {children}
        </div>
      </Content>
    </Layout>
  );
};

export default DashboardLayout;